<template>
  <v-container>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(head, index) in headers"
              :key="index"
              class="table-head"
              @click="sortableColumns.includes(index) ? sort(index) : null"
            >
            {{ head }}
            <element v-if="currentSort == index && sortableColumns.includes(index)">
              <v-icon v-if="sorted[index]" small>mdi-arrow-down</v-icon>
              <v-icon v-else small>mdi-arrow-up</v-icon>
            </element>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(process, index) in currentRows"
            :key="index"
          >
            <td>
              {{ process.name }}
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs}">
                  <span v-bind="attrs" v-on="on">{{ time2Elapsed(process.startTime) }}</span>
                </template>
                <span>{{ $d(new Date(process.startTime), 'long', 'is-IS') }}</span>
              </v-tooltip>
            </td>
            <td>
            </td>
            <td>
              {{ process.taskName }}
            </td>
            <td>
              <v-btn icon @click="continueProcess(process.processInstanceId)">
                <v-icon>mdi-login-variant</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row v-if="pageCount > 0" no-gutters justify="end" align="right">
      <v-col cols="5" md="6" class="d-flex align-items-center justify-content-end mr-3">
        <span>{{ $t('common.rowsPerPage') }}</span>
      </v-col>
      <v-col cols="2" class="d-flex align-items-center justify-content-center mr-2">
        <v-select
          :items="rowsPerPageItems"
          :value="rowsPerPage"
          :label="null"
          hide-details
          @change="changeRowsPerPage"
        ></v-select>
      </v-col>
      <v-col class="d-flex align-items-center justify-content-center">
        <v-btn icon :disabled="currentPage <= 1" @click="previousPage">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2" class="d-flex align-items-center justify-content-center">
        <span>{{ currentPage }} / {{ pageCount }}</span>
      </v-col>
      <v-col class="d-flex align-items-center justify-content-center">
        <v-btn icon :disabled="currentPage >= pageCount" @click="nextPage">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-progress-circular v-if="isLoading" indeterminate color="#033e8c" class="text-center"></v-progress-circular>
  </v-container>
</template>

<script>
function compareDateTime(a, b) {
  const dateA = Date.parse(a.startTime)
  const dateB = Date.parse(b.startTime)

  if (dateA < dateB) {
    return -1
  }

  if (dateA > dateB) {
    return 1
  }

  return 0
}

function compareString(a, b, field) {
  const valueA = a[field].toUpperCase()
  const valueB = b[field].toUpperCase()

  if (valueA < valueB) {
    return -1
  }
  
  if (valueA > valueB) {
    return 1
  }

  return 0
}

export default {
  name: "ProcessTable",
  props: {
  },
  data() {
    return {
      processes: null,
      isLoading: false,
      sorted: [false, false, false, false],
      currentSort: -1,
      currentPage: 1,
      rowsPerPage: 5,
      sortableColumns: [0, 1, 3],
      rowsPerPageItems: [5, 10, 15, 20, 25]
    }
  },
  computed: {
    headers: function () {
      return this.$t('dashboard.processTable.headers')
    },
    currentRows: function () {
      if (this.processes)
        return this.processes.slice((this.currentPage - 1) * this.rowsPerPage, this.currentPage * this.rowsPerPage)
      else
        return []
    },
    pageCount: function () {
      if (this.processes)
        return Math.ceil(this.processes.length / this.rowsPerPage)
      else 
        return 0
    }
  },
  watch: {
    rowsPerPage: function() {
      this.currentPage = 1
    }
  },
  methods: {
    continueProcess(pid) {
      this.$store.commit('setCurrentProcess', pid)
    },
    time2Elapsed(deploymentTime) {
      const dd = Date.parse(deploymentTime)
      const now = Date.now()

      if (dd > now) {
        console.log("Invalid Datetime")
      }

      const diff = Math.abs(dd - now) // in millisseconds
      const diffDays = Math.floor(diff / 86400000);
      const diffHours = Math.floor((diff % 86400000) / 3600000);
      const diffMins = Math.round(((diff % 86400000) % 3600000) / 60000);

      let resultString = ''
      if (diffDays > 0) {
        resultString = this.$tc('dashboard.processTable.elapsed.day', diffDays, { count: diffDays })
      } else {
        if (diffHours > 0) {
          resultString = this.$tc('dashboard.processTable.elapsed.hour', diffHours, { count: diffHours })
        } else {
          if (diffMins > 0) {
            resultString = this.$tc('dashboard.processTable.elapsed.minute', diffMins, { count: diffMins })
          } else {
            resultString = this.$t('dashboard.processTable.elapsed.moment')
          }
        }
      }
      // console.log("%i Days %i Hours %i Minutes", diffDays, diffHours, diffMins)
      return resultString
    },
    sort(index) {
      this.sorted[index] = !this.sorted[index]
      this.currentSort = index
      if (index == 0) {
        this.processes.sort(this.sorted[index] == false ? (a, b) => compareString(a, b, 'name') : (a, b) => -compareString(a, b, 'name'))
      } else if (index == 1) {
        this.processes.sort(this.sorted[index] == false  ? (a, b) => compareDateTime(a, b) : (a, b) => -compareDateTime(a, b)) 
      } else if (index == 3) {
        this.processes.sort(this.sorted[index] == false ? (a, b) => compareString(a, b, 'taskName') : (a, b) => -compareString(a, b, 'taskName'))
      } 
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    changeRowsPerPage(value) {
      this.rowsPerPage = value
    }
  },
  created() {
    this.isLoading = true
    
    this.axios.get('/BPM/process/active', {} , { withCredentials: true })
    .then(response => {
      this.processes = response.data.data
      this.sort(1)
    })
    .catch(error => {
      console.log("Failed to retrieve deployment data.", error)
    })
    .finally(() => {
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.table-head {
  cursor: pointer;
}

.rows-per-page {
  font-size: 0.875rem;
}

.v-text-field {
  padding-top: 0;
  margin-top: 0;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: black !important;
  font-size: 0.75rem !important;
}
</style>